import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { PricingProfileAction } from './pricingProfile.action';
import { pricingProfileInitialState } from './pricingProfile.constant';
import { IPricingProfileStore } from './pricingProfile.interface';

export const pricingProfileReducer = reducerWithInitialState(pricingProfileInitialState)
  .case(PricingProfileAction.loadList.started, (state) => ({
    ...state,
    networkStatus: NetworkStatus.Started,
  }))
  .case(PricingProfileAction.loadList.done, (state, { result }): IPricingProfileStore => {
    const data = {};
    result.forEach((item) => {
      data[item.id] = item;
    });

    return {
      ...state,
      data,
      networkStatus: NetworkStatus.Done,
    };
  })
  .case(PricingProfileAction.loadList.failed, (state) => ({
    ...state,
    networkStatus: NetworkStatus.Failed,
  }))
  .case(PricingProfileAction.remove.done, (state, { params }): IPricingProfileStore => {
    const { data } = state;
    const { id } = params;

    const newData = { ...data };
    delete newData[id];

    return {
      ...state,
      data: newData,
    };
  })
  .case(PricingProfileAction.destroy, () => ({
    ...pricingProfileInitialState,
  }));
